import { styled } from "styled-components";
import type { SearchResultEvent } from "../../lib/DbEventSearcher";
import type { DbNetworkEventWithSearchResults } from "../../lib/searchRecordedEvent";

export const InteractiveRequestIdElement = styled.a.attrs({href: '#'})`
	font-size: 80%;
	color: rgba(32, 0, 32, 1);
	text-decoration-color: rgba(32, 0, 32, 0.25);
`

export const InteractiveRequestId = ({
	displayJson,
	event
}: {
	event: DbNetworkEventWithSearchResults;
	displayJson?: (event: unknown) => void;
}) => {
	const copyFullSearchResult = async (searchResultEvent: SearchResultEvent) => {
		const fullSearchResultJson = JSON.stringify(searchResultEvent, null, "\t");
		await navigator.clipboard.writeText(fullSearchResultJson);
	}
	return (
		<InteractiveRequestIdElement onClick={(e) => { e.preventDefault(); 
			// copyFullSearchResult(event);
			displayJson?.(event);
		}}>{event.raw.requestId}</InteractiveRequestIdElement>
	);
}